<div
  class="modal fade loading-dialog"
  [class.loading-dialog-stacked]="stackAboveModal"
  [id]="modalId"
  tabindex="-1"
  [attr.aria-labelledby]="modalId + 'Label'"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered loading-dialog-container">
    <div class="modal-content loading-dialog-content">
      <div class="loading-dialog-spinner" aria-hidden="true"></div>
      <h5 class="loading-dialog-title" [id]="modalId + 'Label'">{{ title }}</h5>
      <p class="loading-dialog-message">{{ message }}</p>
    </div>
  </div>
</div>
